import * as React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLanguage } from "./Language";
import { RequestButton, ResourceWithAvailability } from "./RequestButton";

export interface ResultButtonsProps {
  resource: ResourceWithAvailability;
  onClickAddToList: (event: React.MouseEvent<Element, MouseEvent>) => void;
  onClickPlaceRequest: (event: React.MouseEvent<Element, MouseEvent>) => void;
  onClickCheckoutDownloadable: (
    event: React.MouseEvent<Element, MouseEvent>
  ) => void;
}

export const ResultButtons: React.FC<ResultButtonsProps> = (props) => {
  const {
    resource,
    onClickAddToList,
    onClickPlaceRequest,
    onClickCheckoutDownloadable,
  } = props;
  const { translate } = useLanguage();
  const [findOnShelf, setFindOnShelf] = React.useState<string | null>(null);
  const theme = useTheme();
  const isBelowMedium = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    const { holdingForOnShelf, rtype } = resource;
    if (holdingForOnShelf && rtype === 1) {
      const { collectionName, shelfLocation } = holdingForOnShelf;
      const findOnShelf = [collectionName?.trim(), shelfLocation?.trim()]
        .filter((token) => token?.length > 0)
        .join(" - ");
      setFindOnShelf(findOnShelf);
    }
  }, [resource]);

  return (
    <Stack
      direction={isBelowMedium ? "column-reverse" : "row"}
      gap={1}
      alignItems={isBelowMedium ? "flex-start" : "center"}
    >
      {resource.showRequestButton && (
        <RequestButton
          sx={{ flexShrink: 0 }}
          resource={resource}
          onClickCheckoutDownloadable={onClickCheckoutDownloadable}
          onClickPlaceRequest={onClickPlaceRequest}
          onClickViewSite={(event, resource) => {
            console.log("News Feed link clicked");
            // TODO analytics
            // search for .external handlers
          }}
          onClickDownloadableLink={(event, resource) => {
            // TODO analytics
            // search for .external handlers
            console.log("Downloadable Link clicked");
          }}
        ></RequestButton>
      )}
      <Button
        sx={{ flexShrink: 0 }}
        variant="outlined"
        onClick={onClickAddToList}
      >
        {translate("addToList")}
      </Button>
      {findOnShelf && (
        <Box sx={{ flexShrink: 1 }}>
          <Typography sx={{ lineHeight: "1" }} variant="overline">
            {translate("findOnShelf")}
          </Typography>
          <Typography sx={{ padding: 0 }}>{findOnShelf}</Typography>
        </Box>
      )}
    </Stack>
  );
};
